import api from "../../../../app/services/api";

const FIND_FAQS_URL = "/knowledge/find/type/1";
const FIND_VIDEOS_URL = "/knowledge/find/type/2";
const FIND_MANUALS_URL = "/knowledge/find/type/3";
const FIND_UPDATES_URL = "/knowledge/find/type/4";
const FIND_LINKS_URL = "/knowledge/find/type/5";
const FIND_NEWSLETTER_URL = "/knowledge/find/type/6";

export function findFaqs(queryParams) {
  return api.post(`${FIND_FAQS_URL}`, queryParams);
}

export function findVideos(queryParams) {
  return api.post(`${FIND_VIDEOS_URL}`, queryParams);
}

export function findManuals(queryParams) {
  return api.post(`${FIND_MANUALS_URL}`, queryParams);
}

export function findUpdates(queryParams) {
  return api.post(`${FIND_UPDATES_URL}`, queryParams);
}

export function findLinks(queryParams) {
  return api.post(`${FIND_LINKS_URL}`, queryParams);
}

export function findNewsletter(queryParams) {
  return api.post(`${FIND_NEWSLETTER_URL}`, queryParams);
}
